export default __webpack_public_path__ + "static/media/after school clubs.dc9cbada.jpg";